import React from "react";

/**
 * Signature element: an animated ECG trace.
 * Used as a divider on the login card and as an ambient accent in the dashboard header —
 * a motif that reads unmistakably "hospital" rather than a generic gradient rule.
 */
export default function PulseLine({ className = "", color = "#5EEAD4", height = 40 }) {
  return (
    <svg
      viewBox="0 0 400 60"
      className={className}
      style={{ height }}
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <path
        d="M0 30 H120 L135 30 L145 8 L160 52 L172 30 L185 30 L195 18 L205 30 H400"
        fill="none"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="1000"
        className="animate-pulseLine"
      />
    </svg>
  );
}
